module.exports = __webpack_public_path__ + "assets/d40496a7c545a30180bc2fffbf677da3.png";